import { ConsignmentDetails } from 'types';
import { DashboardHistoryAndTracking } from 'components';

interface Props {
  consignment: ConsignmentDetails;
}

export function StepNone({ consignment }: Props) {
  const { code } = consignment;

  return <DashboardHistoryAndTracking consignmentCode={code} />;
}
